// Auto-generated file. Do not edit manually.
export const APP_VERSION = '1.0.0';
